module.exports = __webpack_public_path__ + "img/interest.01560321.svg";